import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { getAccountIcon } from '../utils/accountIcons';

// Insignia circular con el ícono/banco/tarjeta detectado para una cuenta
// (ver utils/accountIcons.js) -- un mismo componente para usar en la
// tabla de Cuentas, los selectores de Calendario/Transacciones y
// cualquier otro lugar que liste cuentas.
const AccountIconBadge = ({ nombre, entidad, tipo, size = 32 }) => {
  const info = getAccountIcon({ nombre, entidad, tipo });

  return (
    <Tooltip title={info.nombre || ''}>
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          bgcolor: info.kind === 'red' ? '#fff' : info.color,
          border: info.kind === 'red' ? '1px solid' : 'none',
          borderColor: 'divider',
        }}
      >
        {info.kind === 'red' && <info.Icon size={Math.round(size * 0.6)} color={info.color} />}
        {info.kind === 'banco' && (
          <Typography sx={{ color: '#fff', fontWeight: 'bold', fontSize: size * 0.28, lineHeight: 1 }}>
            {info.iniciales.slice(0, 4)}
          </Typography>
        )}
        {info.kind === 'tipo' && <info.Icon sx={{ color: '#fff', fontSize: size * 0.6 }} />}
      </Box>
    </Tooltip>
  );
};

export default AccountIconBadge;
